import { html } from 'lit';

export const cookieColumns = [
  {
    name: 'origins',
    header: 'Origin(s)',
    bodyRenderer: (row: any) => html` <span>${row.origins.join(', ')}</span>`,
  },
  {
    name: 'cookie',
    header: 'Cookie',
    bodyRenderer: (row: any) => html` <span>${row.cookie}</span>`,
  },
  {
    name: 'provenance',
    header: 'Provenance',
    bodyRenderer: (row: any) => html` <span>${row.provenance}</span>`,
  },
  {
    name: 'lifespan',
    header: 'Lifespan',
    bodyRenderer: (row: any) => html` <span>${row.lifespan}</span>`,
  },
];

export const cookieStrictlyNecessary = [
  {
    origins: ['login.digitalrealty.com', 'login.interxion.com'],
    cookie: '.AspNetCore.Session',
    provenance: 'First Party',
    purpose: 'Essential',
    lifespan: 'Session',
  },
  {
    origins: ['login.digitalrealty.com', 'login.interxion.com'],
    cookie: '.AspNetCore.Antiforgery',
    provenance: 'First Party',
    purpose: 'Essential',
    lifespan: 'Session',
  },
  {
    origins: ['login.digitalrealty.com', 'login.interxion.com'],
    cookie: '.AspNetCore.Identity.Application',
    provenance: 'First Party',
    purpose: 'Essential',
    lifespan: 'Session',
  },
  {
    origins: ['login.digitalrealty.com', 'login.interxion.com'],
    cookie: 'idsrv.session',
    provenance: 'First Party',
    purpose: 'Essential',
    lifespan: 'Session',
  },
];

export const cookiePerformance = [
  {
    origins: ['digitalrealty.com'],
    cookie: '_ga, _ga_LFMMHXPDZK',
    provenance: 'First Party',
    purpose: 'Performance',
    lifespan: 'Up to 2 years',
  },
];

export const cookieTargeting = [
  {
    origins: ['qualtrics.com'],
    cookie: 'QSI_S… , mtko_trk, amplitude_id_…',
    provenance: 'Third Party',
    purpose: 'Tracking',
    lifespan: '6 months',
  },
];
